










































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IRootStoreState } from "../store/root";
import { RecommendationExtra } from "../store/model";

@Component
export default class Footer extends Vue {
  dialog = false;

  get selectedRows(): RecommendationExtra[] {
    return (this.$store.state as IRootStoreState).coreTableStore!.selected;
  }

  get selectedRowsCount(): number {
    return this.selectedRows.length;
  }

  get savingsFromSelected(): number {
    return this.selectedRows
      .filter(recommendation => recommendation.costCol < 0)
      .reduce((acc, cur) => acc - cur.costCol, 0);
  }

  get spendingsFromSelected(): number {
    return this.selectedRows
      .filter(recommendation => recommendation.costCol > 0)
      .reduce((acc, cur) => acc + cur.costCol, 0);
  }

  get performanceSelectedCount(): number {
    return this.selectedRows
      .filter(recommendation => recommendation.costCol > 0)
      .reduce(acc => acc + 1, 0);
  }

  get applyPart(): string {
    return `Apply ${this.selectedRowsCount} recommendation${
      this.selectedRowsCount == 1 ? "" : "s"
    }.`;
  }

  get savingsPart(): string {
    const savings = this.savingsFromSelected;
    if (savings === 0) {
      return "";
    }

    return ` Save ${savings.toFixed(
      2
    )}$ each week by using only the necessary resources.`;
  }

  get spendingsPart(): string {
    if (this.performanceSelectedCount === 0) {
      return "";
    }

    return ` Increase performance of ${this.performanceSelectedCount} machine${
      this.performanceSelectedCount == 1 ? "" : "s"
    }, by spending ${this.spendingsFromSelected.toFixed(2)}$ more each week.`;
  }

  get footerMessage(): string {
    return this.applyPart + this.savingsPart + this.spendingsPart;
  }

  applySelectedRecommendations(): void {
    this.$store.dispatch(
      "recommendationsStore/applyGivenRecommendations",
      this.selectedRows.map(row => row.name)
    );
    this.$store.commit("coreTableStore/setSelected", []);
  }
}
